
import React from 'react';
import { Link } from 'react-router-dom';

const CaseStudyCard = ({ image, title, tags , link , alt }) => {
  return (
    <div>
       <Link to={link}>
      <img
        src={image}
        alt={alt}
        className="object-cover rounded-md"
      />
      <h3 className="mt-4 text-[24px] leading-[32px] lg:tracking-[-0.06em] lg:text-[24px] lg:leading-[36px] font-semibold hover:underline underline-offset-[4px] decoration-[0.2px] decoration-solid">
        {title}
      </h3>
      <div className="flex flex-wrap gap-2 mt-4 lg:mt-4 rounded-lg">
        {tags.map((tag, i) => (
          <span
            key={i}
            className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5 rounded"
          >
            {tag}
          </span>
        ))}
      </div>
      </Link>
    </div>
  );
};

export default CaseStudyCard;
